// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"TileContent_contentWrapper__rKI9n","value":"TileContent_value__19_gC","wrappedContent":"TileContent_wrappedContent__1EO2-"};